import React, { useState, useEffect } from 'react'

import { Button, Card, Col, Form, Icon, notification, Row, Typography } from 'antd'
import { Formik } from 'formik'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomSelect from '../../components/CustomSelect/customSelect'
import CustomTreeTransfer from '../../components/CustomTreeTransfer/CustomTreeTransfer'
import FormHeader from '../../components/FormHeader/FormHeader'

import './team.css'

import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { orderObjects } from '../../util/orderObjects'

const CreateTeam = ({ match, history }) => {
  // Params url
  const { id } = match.params
  // UseStates
  const [formValues, setFormValues] = useState([])
  const [users, setUsers] = useState([])

  const [valuesLeft, setValuesLeft] = useState([])
  const [valuesLeftSelected, setValuesLeftSelected] = useState([])

  const [valuesRight, setValuesRight] = useState([])
  const [valuesRightSelected, setValuesRightSelected] = useState([])

  const [selectedManager, setSelectedManager] = useState(0)
  const [currentMemberLink, setCurrentMemberLink] = useState([])

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.TEAM) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    onCreateContainer()
    if (id) {
      retrieveTeams(id)
    }
  }, [])

  async function onCreateContainer() {
    await listUsers({ active: true })
    await listMembers({ active: true })
  }

  async function listUsers(params) {
    try {
      const response = await request(api.listMembers(params))
      const formattedData = []
      response.map((item) => {
        return formattedData.push({
          value: item.id.toString(),
          description: item.name
        })
      })
      setUsers(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listMembers(params) {
    try {
      const response = await request(api.listMembers(params))
      const formattedValues = []
      response.map((item) => {
        return formattedValues.push({
          key: `${item.id}`,
          title: item.name
        })
      })
      formattedValues.sort(orderObjects('description'))
      setValuesLeft(formattedValues)
    } catch (error) {
      console.tron.log(error)
    }
  }

  function addInRightList() {
    if (!Array.isArray(valuesLeftSelected)) {
      return
    }

    const newValuesLeft = valuesLeft.filter((value) => !valuesLeftSelected.includes(value.key))
    const newValuesRight = valuesLeft.filter((value) => valuesLeftSelected.includes(value.key))
    setValuesLeft(newValuesLeft)
    setValuesLeftSelected([])
    setValuesRight([...valuesRight, ...newValuesRight])
  }

  function removeFromRightList() {
    if (!Array.isArray(valuesRightSelected)) {
      return
    }

    const newValuesRight = valuesRight.filter((value) => !valuesRightSelected.includes(value.key))
    const newValuesLeft = valuesRight.filter((value) => valuesRightSelected.includes(value.key))
    setValuesRight(newValuesRight)
    setValuesRightSelected([])
    setValuesLeft([...valuesLeft, ...newValuesLeft])
  }

  // Cruds
  async function retrieveTeams(id) {
    try {
      const response = await request(api.listMembersLink({ managerId: id }))
      setCurrentMemberLink(response)
      let formattedMembers = []
      if (response) {
        formattedMembers = response.map((item) => {
          return {
            key: `${item.id}`,
            title: item.memberName
          }
        })

        setValuesRight(formattedMembers)
        setFormValues({
          manager: response[0].managerName,
          managerId: response[0].managerId
        })
      }
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id ? getMessage('updateTeam') : getMessage('createTeam')
  }

  // Form/formik config
  const form = {
    initialValues: {},
    onSubmit: async (values) => {
      if (Array.isArray(valuesRight) && valuesRight.length > 0) {
        const payload = []

        valuesRight.forEach((item) => {
          payload.push({
            managerId: isNaN(values.managerId) ? Number(selectedManager) : Number(values.managerId),
            memberId: Number(item.key),
            memberGroupId: null
          })
        })

        !id ? storeGroup(payload) : updateGroup(payload)
      }
    }
  }

  async function storeGroup(data) {
    try {
      data.map(async (memberLink) => {
        await request(api.storeMembersLink(memberLink))
      })

      notification.success({
        description: getMessage('successStoreActions'),
        message: getMessage('sweetAlerts.success')
      })

      setFormValues([])
      history.push('/team/list')
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateGroup(data) {
    try {
      let current = valuesRight.map((c) => Number(c.key))
      let notUpdate = currentMemberLink.map((c) => c.id)

      if (current.length < notUpdate.length) {
        let difference = notUpdate.filter((x) => !current.includes(x))

        difference.map(async (memberLink) => {
          await request(api.removeMembersLink(memberLink))
        })
      } else {
        data.map(async (memberLink) => {
          if (!notUpdate.includes(memberLink.memberId)) {
            await request(api.storeMembersLink(memberLink))
          }
        })
      }

      notification.success({
        description: getMessage('successUpdateActions'),
        message: getMessage('sweetAlerts.success')
      })

      setFormValues([])
      history.push('/team/list')
    } catch (error) {
      console.tron.log(error)
    }
  }

  function renderHeader(submitForm) {
    const hasAccess = validRule(RULES.TEAM)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  function renderNameAndFilter(values, errors, handleBlur, setFieldValueWithState) {
    return (
      <Row type="flex">
        <CustomSelect
          showSearch
          field="manager"
          placeholder={getMessage('typeToFind')}
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={12}
          value={formValues}
          values={users}
          onChange={(e) => setSelectedManager(e)}
          required={true}
        />
      </Row>
    )
  }

  function renderTreeTransfer() {
    return (
      <Row className="tree-row" type="flex" align="middle">
        <Col span={10}>
          <CustomTreeTransfer
            label={getMessage('filterByName')}
            values={valuesLeft}
            selectedValues={valuesLeftSelected}
            checkedValues={valuesLeftSelected}
            setSelectedStateValue={setValuesLeftSelected}
          />
        </Col>
        <Col span={2}>
          <Button type="primary" onClick={addInRightList}>
            <Icon type="double-right" />
          </Button>
          <div style={{ height: 20 }} />
          <Button type="primary" onClick={removeFromRightList}>
            <Icon type="double-left" />
          </Button>
        </Col>
        <Col span={10} className="wallet-separator-right">
          <CustomTreeTransfer
            label={getMessage('filterByName')}
            values={valuesRight}
            selectedValues={valuesRightSelected}
            checkedValues={valuesRightSelected}
            setSelectedStateValue={setValuesRightSelected}
          />
        </Col>
      </Row>
    )
  }

  return (
    <Formik
      enableReinitialize
      initialValues={formValues}
      onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
        form.onSubmit(values, setSubmitting, setFieldError, resetForm)
      }
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
        const setFieldValueWithState = (field, value) => {
          setFormValues({ ...formValues, [field]: value })
          return setFieldValue(field, value)
        }

        return (
          <Form className="login-form" layout={'vertical'} onSubmit={handleSubmit}>
            {renderHeader(submitForm)}
            <Card className="ant-card gx-card ant-card-bordered">
              <Typography.Title className="default-header-title" level={3}>
                {getTitle()}
              </Typography.Title>
              {renderNameAndFilter(values, errors, handleBlur, setFieldValueWithState)}
              <FormHeader title={getMessage('teamMembers')} orientation="left" type="horizontal" />
              {renderTreeTransfer()}
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

export default CreateTeam
